// React
import React, { Component } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
// Routing
import { withRouter } from "react-router-dom";
// Material UI
import { Divider, Drawer, IconButton } from '@material-ui/core';
// Components
import {Button} from '@components/Input';
// Translations
import {withTranslation} from "react-i18next";
// ICONS
import {arrowLeftSvg, ticketSvg} from '@assets';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
// STYLES
import { withStyles } from '@material-ui/core/styles';
import '@components/Sidebars/CommentsNotifySidebar/styles/styles.scss';
import {getSidebarStyles} from '@components/Sidebars/CommentsNotifySidebar/styles/styles';

const useStyles = (theme) => (getSidebarStyles(theme, 'right'));

class CommentsNotifySidebar extends Component {

    handleTicket = (e, ticket) => {
        const { cleanSocketsTicketById, viewSocketsTicket } = this.props;
        this.props.dispatch(viewSocketsTicket({
            id: ticket.id,
            auto_id: ticket.auto_id,
            status_id: ticket.status_id
        }));
        this.props.dispatch(cleanSocketsTicketById(ticket.id));
        this.props.history.push(`/ticket/${ticket.id}`);
        this.props.handleMenuToggle();
    }

    render() {
        const {t, classes, open, handleMenuToggle, cleanAllSocketTickets} = this.props;
        const {sockets} = this.props.data;

        var commentsLength = Object.keys(sockets?.eventTickets)?.length;
        return (
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx(classes.paper, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                {
                    <IconButton
                        disableRipple disableFocusRipple
                        onClick={handleMenuToggle}
                        className={clsx(classes.collapseButton, {
                            [classes.collapseButtonOpen]: open,
                            [classes.collapseButtonClose]: !open
                        })}
                    >
                        {
                            open ? (
                                <ChevronRightIcon style={{ fontSize: 18 }} />
                            ) : (
                                <ChevronLeftIcon style={{ fontSize: 18 }} />
                            )
                        }
                    </IconButton>
                }
                <div className={"comments_sidebar"}>
                    <Divider/>
                    <div className={"comments_header"}>
                        <h2>Tickets</h2>
                        {
                            commentsLength > 0 &&
                                <Button onClick={() => this.props.dispatch(cleanAllSocketTickets())} text={t('commons:sidebars.comments.clean_events')} type={"success"} />
                        }
                    </div>
                    <div className={"comments_tickets"}>
                        {commentsLength > 0 ?
                            Object.entries(sockets?.eventTickets).map(([key, comment]) =>
                                <div key={key} className={`comments ${comment.ticket.status}`} onClick={(e) => this.handleTicket(e, comment.ticket)}>
                                    <div className={"comments_badge"}><div className={"mini_badge"}/>{ticketSvg()}</div>
                                    <span className={"comments_icon"}>{arrowLeftSvg()}</span>
                                    <h3>{`Ticket #${comment.ticket.auto_id}`}</h3>
                                    {
                                        comment.event === 'ticket_created' ?
                                            <React.Fragment>
                                                <span>{t('commons:sidebars.comments.new_ticket')}</span>
                                                <span>{comment.ticket.subject}</span>
                                                <div className={"comments_time"}>
                                                    <span>{comment.ticket.created_at.split(" ")[0]}</span>
                                                    <span>{comment.ticket.created_at.split(" ")[1]}</span>
                                                </div>
                                            </React.Fragment> :
                                            <React.Fragment>
                                                <span>{t('commons:sidebars.comments.new_comment')}</span>
                                                <span>{comment.comment.text}</span>
                                                <div className={"comments_time"}>
                                                    <span>{comment.comment.created_at.split(" ")[0]}</span>
                                                    <span>{comment.comment.created_at.split(" ")[1]}</span>
                                                </div>
                                            </React.Fragment>
                                    }
                                </div>
                            )
                            :
                                <div className={"comments_noInfo"}>
                                <div>{ticketSvg()}</div>
                                <span>{t('commons:sidebars.comments.events_not_found')}</span>
                            </div>
                        }
                    </div>
                </div>
            </Drawer>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    }
}

const c = connect(
    mapStateToProps
)(CommentsNotifySidebar);

export default withRouter(withTranslation()(withStyles(useStyles)(c)));